import { normalizeString } from "../functions";

const patientSchema = {
  firstName: (firstName) =>
    normalizeString({ data: firstName, actions: ["spacing"] }),
  lastName: (lastName) =>
    normalizeString({ data: lastName, actions: ["spacing"] }),
};

export default patientSchema;
